import angular from 'angular';
import template from './file-current.html';
import Defaults from '~/scripts/constants/defaults';
import './file-current.scss';

/* globals Knitiv */

const fileCurrentConfig = /* @ngInject */ (/** @type {any} */ KformComponentsProvider) => {
	KformComponentsProvider.register('file-current', {
		title:                  'File (current)',
		template,
		group:                  'advanced',
		children:               false,
		selectable:             true,
		settings:               {
			disabled:  false,
			key:       'fileCurrent',
			label:     'File (current)',
			hideLabel: false,
			input:     false,
			tableView: false,
			hidden:    false,
		},
		icon:                   'fa fa-file',
		views:                  [
			{
				name:     'Display',
				template: 'kform/components/file-current/display.html',
			},
			{
				name:     'API',
				template: 'kform/components/file-current/api.html',
			},
			{
				name:     'Layout',
				template: 'kform/components/common/layout.html',
			},
			{
				name:     'Conditional',
				template: 'kform/components/common/conditional.html',
			},
		],
		controller: /* @ngInject */ (
			/** @type {import('angular').auto.IInjectorService} */ $injector,
			/** @type {import('angular').ILocationService} */ $location,
			/** @type {Knitiv.RootScope} */ $rootScope,
			/** @type {import('angular').translate.ITranslateService} */ $translate,
			/** @type {any} */ $scope,
			/** @type {import('~/scripts/services/form.service').default} */ FormService,
			/** @type {import('~/components/download/download.service').FileDownloadServiceModel} */ FileDownloadService,
		) => {
			$scope.Defaults = Defaults;
			$scope.kds = $rootScope.kds;

			if ($scope.file?.file) {
				$scope.files.push($scope.file);
			}

			/**
			 * @param {File} file
			 * @param {File[]} files
			 */
			$scope.addFiles = (file, files) => {
				if ($scope.kds) {
					$scope.kform.addFiles(files)
				}
				else {
					$scope.kform.addFile(file)
				}
			}

			/**
			 * Removes a file from the specified form
			 *
			 * @param {number} k
			 */
			$scope.detachFile = async k => {
				if ($scope.form) {
					const resultDetachFile = await $scope.kform?.detachFile($scope.form, $scope.files[k]);
					if (resultDetachFile) {
						$scope.files.splice(k, 1);
					}
				}
			};

			/**
			 * Downloads the file of the current form
			 */
			$scope.download = async () => {
				if ($scope.form?.checkDroit(Defaults.DROIT.READ)) {
					await FileDownloadService.download([{ kid: $scope.form.kid }]);
				}
			};

			$scope.path = $location.path();

			$scope.openTabFile = (/** @type {string} */ id) => {
				$location.search({
					tab: 'file',
					id,
				});
			};
		},
	});
};

export default angular.module('app').config(fileCurrentConfig);
